<template>
  <v-main class="pa-4" fluid>
    <v-row>
      <v-col cols="12" md="8" lg="6">

        <v-card class="shadowCard">

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold"> Categorías </span>
	  		    <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mr-2"  @click="nuevaCategoria = true"> Nuevo </v-btn>
	  		    <v-btn color="secondary" dark  class="mr-2" @click="initialize()">  Actualizar </v-btn>
	  		  </v-card-title>
          
          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
              <v-col cols="12" md="12" lg="10">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  dense
                  hide-details
                  append-icon="mdi-magnify" 
                  v-model="search"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="categorias"
                  :height="tamanioPantalla"
                  fixed-header
                  :loading ="loading"
                  :search="search"
                  dense
                >
                  <template v-slot:item.editar="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)"  color="blue">  mdi-pencil </v-icon>
                  </template>
                 
                  <template v-slot:item.estatus="{ item }">
                    <v-chip v-if="item.estatus == 1" color="green" dark small>Activo</v-chip>
                    <v-chip v-else color="red" dark small>Inactivo</v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          
        </v-card>
                      
        <v-dialog v-model="nuevaCategoria" width="500px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title> <span class="font-weight-bold text-h5">{{ formTitle }}</span> </v-card-title>

              <v-card-text class="mt-3">
                <!-- <v-autocomplete
                  v-model="familia"
                  :items="familias"
                  label="Familias"
                  return-object
                  item-text="familia"
                  item-value="idfammilias"
                  :rules="[v => !!v || 'Campo requerido']"
                  filled
                  dense
                ></v-autocomplete> -->

                <v-text-field
                  v-model="editedItem.categoria"
                  label="Categoría"
                  filled
                  dense
                  :rules="[v => !!v || 'Campo requerido']"
                ></v-text-field>

                <!-- <div v-if="!file && !editedItem.foto">
                  <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                    <div class="dropZone-info" @drag="onChange">
                      <span class="fa fa-cloud-upload dropZone-title"></span>
                      <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                      <div class="dropZone-upload-limit-info">
                        <div>Extensión: png, jpg, jpeg, svg</div>
                        <div>Tamaño máximo: 10 MB</div>
                      </div>
                    </div>
                    <input type="file" @change="onChange">
                  </div>
                </div>

                <v-btn  v-else color="red" class="mb-2" dense @click="removeFile" fab small dark><v-icon>mdi-delete</v-icon></v-btn>
                <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="200"/>
                <v-img :src="url + editedItem.foto" v-else-if="editedItem.foto" contain max-height="200"/> -->

                <v-checkbox label="Estatus" v-model="editedItem.estatus"></v-checkbox>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" outlined @click="nuevaCategoria = false"> Cancelar </v-btn>
                <v-btn color="primary darken-1"      @click="save">  Guardar  </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="dialogDelete" width="500px">
          <v-card>
            <v-card-title class="text-h5">¿Estas seguro de querer eliminar esté registro?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" outlined @click="dialogDelete = false">Cancelar</v-btn>
              <v-btn color="blue darken-1" @click="deleteItemConfirm">Eliminar</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
       
      </v-col>
    </v-row>
  </v-main>
</template>
<script>
  import  metodos from '@/mixins/metodos.js';

  export default {
    mixins:[metodos],
    data: () => ({
      valid: true,
      search:'',
      text:'',
      color:'',
      snackbar: false,
      nuevaCategoria: false,
      dialogDelete: false,
      headers: [
        { text: 'Id', align: 'left',sortable: false, value: 'idcategorias'},
        { text: 'Categoría', align: 'left',sortable: false, value: 'categoria'},
        // { text: 'Familia'  , align: 'left',sortable: false, value: 'familia'},
        { text: 'Estatus'  , align: 'left',sortable: false, value: 'estatus'},
        { text: 'Editar'   , align: 'left',sortable: false, value: 'editar'},
      ],

      categorias: [],
      editedIndex: -1,
      editedItem: {
        idcategorias:0,
        categoria: '',
        idfamilias:0,
        estatus: 0,
        foto:null
      },
      defaultItem: {
        idcategorias:0,
        categoria: '',
        idfamilias:0,
        estatus: 0,
        foto:null
      },

      familia:null,
      familias:[],

      file: '',
      dragging: false,
      archivos:null,
      vistaPrevia: null,
      url:'',

    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva categoría' : 'Editar Categoría'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.url = this.$http.options.root + 'fotos-epic-grass/'
      this.initialize()
    },

    methods: {

      initialize () {
        this.categorias = []
        this.$http.get('categorias.all').then(response =>{
          this.removeFile()
          if(response == null){
            this.loading = false
            this.productos = []
          }else{
            this.loading = false
            this.categorias = response.body

            this.categorias.forEach(element=>{
              element.estatus == 1 ? true:false
            })
          }
        })

        this.$http.get('familias.activo').then(response =>{
          this.familias = response.body
        }).catch(error=>{console.log(error)})
      },

      editItem (item) {
        this.editedIndex = this.categorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.familia = {idfamilias: this.editedItem.idfamilias, familia: this.editedItem.familia}
        this.nuevaCategoria = true
      },

      deleteItem (item) {
        this.editedIndex = this.categorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.categorias.splice(this.editedIndex, 1)
        this.dialogDelete = false;
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      saveFoto ( ){
        return new Promise((resolve, reject) =>{
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo

          formData.append("file", this.file);
          this.$http.post('categorias.foto', formData).then(response=>{
            resolve( response.body.nombre)  
          })
        })
      },


      async save () {
        let foto = this.editedItem.foto
        if( this.file ){
          foto = await this.saveFoto( ).then( response => response )
        }

        this.editedItem.foto = foto

        if(this.$refs.form.validate()){
          this.editedItem.estatus == false ? 0 : 1
          this.editedItem.idfamilias = 0

          if (this.editedIndex > -1) {
            this.$http.put('categorias.update/'+ this.editedItem.idcategorias, this.editedItem).then(response=>{
              this.text  = 'Categoría actualizada'
              this.snackbar = true
              this.color = 'green'
              this.initialize()
            })
          } else {
            this.$http.post('categorias.add', this.editedItem).then(response=>{
              this.text  = 'Categoría agregada'
              this.snackbar = true
              this.color = 'green'
              this.initialize()
            })
          }
          this.nuevaCategoria = false
        }
      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        
        if (!files.length) {
          this.dragging = false;
          return;
        }
        
        this.createFile(files[0]);
      },

      cargarArchivo(){
        if(!this.archivos){ return }
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(this.archivos)
      },

      getBase64(file) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevia = {
            url: reader.result, 
            image_name: file.name
          }
        };
      },

      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('please select txt file');
          this.dragging = false;
          return;
        }
        
        if (file.size > 10000000) {
          alert('please check file size no over 5 MB.')
          this.dragging = false;
          return;
        }
        
        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos)
        this.dragging = false;
      },

      removeFile() {
        this.vistaPrevia        = null
        this.editedItem.foto    = null
        this.archivos           = null
        this.file               = '';
      },
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>